<template>
  <div class="h-100">

    <b-container fluid>
    <h1 class="tw-text-3xl tw-font-medium tw-mb-2 text-aegis-dk">{{title}} Metrics</h1>
    </b-container>

   </div>
</template>

<script>
    // import {
    //     HTTP
    // } from '@/utilities/http-common';
    // import HandleErrors from '@/utilities/handle-errors';

    import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'
    // import {
    //     mapState,
    //     // mapGetters,
    //     // mapActions
    // } from 'vuex';

    export default {
        mixins: [
            DashboardBaseTemplate
        ],
        data: function () {
            return {
                title: 'Program PI'
            }
        },
        computed: {
            // ...mapState('sample', ['sample']),
            // ...mapGetters('sample', ['nameOfGetter'])
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            // ...mapActions('sample', ['nameOfAction']),
            get: function () {
                // HTTP.get('/').then((response) => {
                //     let something = response.data;
                // }).catch((error) => {
                //     HandleErrors.HandleErrors(error);
                // });
            },
            find: function () {

            },
            create: function () {

            },
            patch: function () {

            },
            update: function () {

            },
            delete: function () {

            }
        }
        // beforeRouteEnter(to, from, next) {
        //     // called before the route that renders this component is confirmed.
        //     // does NOT have access to `this` component instance,
        //     // because it has not been created yet when this guard is called!
        // },
        // beforeRouteUpdate(to, from, next) {
        //     // called when the route that renders this component has changed,
        //     // but this component is reused in the new route.
        //     // For example, for a route with dynamic params `/foo/:id`, when we
        //     // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        //     // will be reused, and this hook will be called when that happens.
        //     // has access to `this` component instance.
        // },
        // beforeRouteLeave(to, from, next) {
        //     // called when the route that renders this component is about to
        //     // be navigated away from.
        //     // has access to `this` component instance.
        // },
    }
</script>
